<template>
  <div>
    <template v-if="editable">
      <div class="exam__part__title" v-if="currentTime"><strong>{{ convertSecondsToTime(currentTime) }}</strong></div>
      <div class="exam__part__title" v-if="isFinished">阅读时间结束</div>
      <b-row class="d-flex flex-wrap align-items-center mb-3">
        <b-col v-if="question.image != 0" class="text-center">
          <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
        <b-col v-if="isReading">
          <div v-html="question.content.replace(/  /g, '&nbsp;')" class="question__content"></div>
        </b-col>
        <b-col v-if="!isReading && !isFinished">
          <b-button @click="startReading">10分钟的阅读时间开始</b-button>
        </b-col>
      </b-row>

      <template  v-if="isFinished">
        <b-form-textarea
          id="textarea"
          placeholder="Write down your answer..."
          rows="15"
          class="mt-1"
          v-on:change="inputAnswer"
        ></b-form-textarea>
      </template>
    </template>
    <template v-else>
      <b-row class="d-flex flex-wrap align-items-center mb-3">
        <b-col v-if="question.image != 0" class="text-center">
          <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
        <div v-html="question.content.replace(/  /g, '&nbsp;')" class="question__content"></div>
      </b-row>

      <b-form-textarea
        id="textarea"
        :value="response.answer"
        rows="15"
        class="mt-1"
        v-on:change="inputAnswer"
      ></b-form-textarea>

      <div class="exam__part__title" v-if="response.score">Điểm đạt được: {{ response.score }} điểm</div>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionWritingContent',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isCountdown: false,
      isReading: false,
      isFinished: false,
      currentTime: 0
    }
  },
  mounted() {
    
  },
  methods: {
    convertSecondsToTime(sec) {
      var min = Math.floor(sec / 60)
      var seconds = sec - (min * 60)
      seconds = Math.round(seconds * 100) / 100
      
      var result = min < 10 ? "0" + min : min
      result += ":" + (seconds < 10 ? "0" + seconds : seconds)

      return result
    },
    startReading() {
      this.currentTime = this.question.timeHidden * 60
      this.isReading = true

      this.isCountdown = setInterval(function() {
        // Countdown timer
        this.currentTime = this.currentTime - 1
        // Check if timer = 0
        if (this.currentTime == 0) {
          this.isReading = false
          this.isFinished = true
          clearInterval(this.isCountdown);
        }
        
      }.bind(this), 1000)
    },
    inputAnswer(evt) {
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: evt
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.isCountdown);
  }
}
</script>